import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=21cc5054&scoped=true&"
import script from "./Thumbnail.vue?vue&type=script&lang=ts&"
export * from "./Thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=21cc5054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc5054",
  null
  
)

export default component.exports